import { afterNextRender, DestroyRef, Directive, ElementRef, inject, output } from '@angular/core';

@Directive({ selector: '[libObserveHeightChanges]' })
export class ObserveHeightChangesDirective {
  private readonly element = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly destroyRef = inject(DestroyRef);

  public readonly sizeChanged = output<{ width: number; height: number }>();

  public constructor() {
    afterNextRender(() => {
      const observer = new ResizeObserver(entries => {
        for (const { contentRect: { width, height } } of entries) {
          this.sizeChanged.emit({ width, height });
        }
      });
      observer.observe(this.element.nativeElement);
      this.destroyRef.onDestroy(() => observer.disconnect());
    });
  }
}
